var map = {
	".": 18305,
	"./": 18305,
	"./App": 4274,
	"./App.css": 93508,
	"./App.js": 4274,
	"./App.scss": 5636,
	"./App.test": 78022,
	"./App.test.js": 78022,
	"./Home": 37610,
	"./Home.js": 37610,
	"./adapters/rename.sh": 88414,
	"./adapters/svgs/ARCOM28.svg": 15370,
	"./adapters/svgs/ARCOM28V1.svg": 94868,
	"./adapters/svgs/ARCOM30V1.svg": 81270,
	"./adapters/svgs/Alliance348811HB.svg": 76060,
	"./adapters/svgs/AltecnicEcocal.svg": 28882,
	"./adapters/svgs/BathEmpireRA33S.svg": 51710,
	"./adapters/svgs/BlyssProgrammablethermostat.svg": 84181,
	"./adapters/svgs/BlyssRadio.svg": 41794,
	"./adapters/svgs/BlyssSimple.svg": 11875,
	"./adapters/svgs/Caleffi200.svg": 98158,
	"./adapters/svgs/Caleffi201.svg": 48639,
	"./adapters/svgs/Caleffi202.svg": 850,
	"./adapters/svgs/Caleffi203.svg": 40673,
	"./adapters/svgs/Caleffi204.svg": 53587,
	"./adapters/svgs/Caleffi205.svg": 43667,
	"./adapters/svgs/CaleffiWICAL210.svg": 76405,
	"./adapters/svgs/DanfossConnect-ConnectZ-1.svg": 69528,
	"./adapters/svgs/DanfossConnect-ConnectZ.svg": 88399,
	"./adapters/svgs/DanfossLivingeco1.svg": 97696,
	"./adapters/svgs/DanfossLivingeco2.svg": 99811,
	"./adapters/svgs/DanfossRA2000.svg": 71951,
	"./adapters/svgs/DanfossRA2920.svg": 36926,
	"./adapters/svgs/DanfossRAE-K.svg": 2915,
	"./adapters/svgs/DanfossRAS-C2.svg": 50557,
	"./adapters/svgs/DanfossRAS-CK.svg": 94520,
	"./adapters/svgs/DanfossRAS-D2.svg": 48008,
	"./adapters/svgs/DanfossRAW.svg": 70582,
	"./adapters/svgs/DanfossRAX-1.svg": 86908,
	"./adapters/svgs/DanfossRAX-KChrome.svg": 90906,
	"./adapters/svgs/DanfossRAX-KWhite.svg": 62868,
	"./adapters/svgs/DanfossRAX.svg": 15824,
	"./adapters/svgs/DanfossRAXBlack.svg": 55920,
	"./adapters/svgs/DanfossRAXChrome.svg": 96931,
	"./adapters/svgs/DanfossRAXStainlesssteel.svg": 24630,
	"./adapters/svgs/DanfossRAXStainlesswhite.svg": 13716,
	"./adapters/svgs/DanfossRAXWhite.svg": 54077,
	"./adapters/svgs/DanfossRTW.svg": 45121,
	"./adapters/svgs/DraytonRT112.svg": 79741,
	"./adapters/svgs/DraytonRT212.svg": 49097,
	"./adapters/svgs/DraytonRT312.svg": 76981,
	"./adapters/svgs/DraytonRT313.svg": 57917,
	"./adapters/svgs/DraytonRT412.svg": 19202,
	"./adapters/svgs/DraytonRT414.svg": 51070,
	"./adapters/svgs/DraytonTRV4Chrome-1.svg": 87723,
	"./adapters/svgs/DraytonTRV4Chrome.svg": 97543,
	"./adapters/svgs/DraytonTRV4Classic-1.svg": 44293,
	"./adapters/svgs/DraytonTRV4Classic.svg": 59306,
	"./adapters/svgs/DraytonTRV4White.svg": 27941,
	"./adapters/svgs/ECATRV1.svg": 5105,
	"./adapters/svgs/ECATRV2.svg": 6071,
	"./adapters/svgs/EberleRT212.svg": 33527,
	"./adapters/svgs/EberleRT411D.svg": 49832,
	"./adapters/svgs/EberleRT411DH.svg": 13793,
	"./adapters/svgs/EberleRT414.svg": 35402,
	"./adapters/svgs/EberleTRV4Chrome.svg": 30480,
	"./adapters/svgs/EberleTRV4Classic.svg": 65709,
	"./adapters/svgs/EberleTS-5.11.svg": 46269,
	"./adapters/svgs/EberleTS.svg": 46323,
	"./adapters/svgs/EberleTSDCC.svg": 62676,
	"./adapters/svgs/ErbeleRT212.svg": 48825,
	"./adapters/svgs/ErbeleRT411.svg": 59335,
	"./adapters/svgs/ErbeleRT411D.svg": 99652,
	"./adapters/svgs/ErbeleRT411H.svg": 30288,
	"./adapters/svgs/FAR1610.svg": 85063,
	"./adapters/svgs/FAR1820.svg": 6490,
	"./adapters/svgs/FAR1824.svg": 40314,
	"./adapters/svgs/FAR1825.svg": 62968,
	"./adapters/svgs/FAR1828.svg": 22005,
	"./adapters/svgs/GAMPPERARMATUREN320KD.svg": 88310,
	"./adapters/svgs/GAMPPERARMATUREN320KH....svg": 29522,
	"./adapters/svgs/Gampper320KD.svg": 33611,
	"./adapters/svgs/GiacominiK470H.svg": 91790,
	"./adapters/svgs/GiacominiR460-1.svg": 91025,
	"./adapters/svgs/GiacominiR460.svg": 54096,
	"./adapters/svgs/GiacominiR460H.svg": 58913,
	"./adapters/svgs/GiacominiR462.svg": 52589,
	"./adapters/svgs/GiacominiR463.svg": 92833,
	"./adapters/svgs/GiacominiR468.svg": 19439,
	"./adapters/svgs/GiacominiR468H.svg": 56499,
	"./adapters/svgs/GiacominiR470.svg": 74679,
	"./adapters/svgs/GiacominiR470H.svg": 96168,
	"./adapters/svgs/HeimeierB.svg": 23122,
	"./adapters/svgs/HeimeierD-U.svg": 53311,
	"./adapters/svgs/HeimeierD.svg": 42223,
	"./adapters/svgs/HeimeierDXBeige.svg": 61975,
	"./adapters/svgs/HeimeierDXBlack.svg": 80219,
	"./adapters/svgs/HeimeierDXChrome.svg": 33628,
	"./adapters/svgs/HeimeierDXGrey.svg": 65739,
	"./adapters/svgs/HeimeierDXWhite.svg": 96039,
	"./adapters/svgs/HeimeierF.svg": 36366,
	"./adapters/svgs/HeimeierHeimeierK.svg": 49682,
	"./adapters/svgs/HeimeierHeimeierKold.svg": 48682,
	"./adapters/svgs/HeimeierHeimeierVK.svg": 73152,
	"./adapters/svgs/HeimeierHeimeierVKold.svg": 85729,
	"./adapters/svgs/HeimeierK.svg": 67138,
	"./adapters/svgs/HeimeierKold.svg": 72407,
	"./adapters/svgs/HeimeierTRV300.svg": 33849,
	"./adapters/svgs/HeimeierWK.svg": 83604,
	"./adapters/svgs/HeimeierWKold.svg": 88905,
	"./adapters/svgs/Herz7230-7260.svg": 70655,
	"./adapters/svgs/Herz7235.svg": 53874,
	"./adapters/svgs/Herz7262.svg": 99941,
	"./adapters/svgs/Herz8250.svg": 45646,
	"./adapters/svgs/Herz8251.svg": 19377,
	"./adapters/svgs/Herz9200-9201.svg": 25214,
	"./adapters/svgs/Herz9230-9260.svg": 86079,
	"./adapters/svgs/Herz9860-9860H-9861-9861H.svg": 37855,
	"./adapters/svgs/Honeywell2080.svg": 73545,
	"./adapters/svgs/HoneywellBraukmann2080-1.svg": 18978,
	"./adapters/svgs/HoneywellBraukmann2080.svg": 22227,
	"./adapters/svgs/HoneywellBraukmannRondostatHR20.svg": 94990,
	"./adapters/svgs/HoneywellBraukmannT100M.svg": 79284,
	"./adapters/svgs/HoneywellBraukmannT100V-T100VM.svg": 95293,
	"./adapters/svgs/HoneywellBraukmannThera-100.svg": 46109,
	"./adapters/svgs/HoneywellBraukmannThera-2.svg": 93555,
	"./adapters/svgs/HoneywellBraukmannThera-20.svg": 34482,
	"./adapters/svgs/HoneywellBraukmannThera-200.svg": 72538,
	"./adapters/svgs/HoneywellBraukmannThera-3.svg": 49830,
	"./adapters/svgs/HoneywellBraukmannThera-4Classic.svg": 72498,
	"./adapters/svgs/HoneywellBraukmannThera-4Design.svg": 63024,
	"./adapters/svgs/HoneywellBraukmannThera-EL.svg": 92593,
	"./adapters/svgs/HoneywellBraukmannVT117e-VTL120.svg": 26186,
	"./adapters/svgs/HoneywellBraukmannVT15.svg": 44343,
	"./adapters/svgs/HoneywellBraukmannVT200e.svg": 53945,
	"./adapters/svgs/IVARDH01.svg": 30234,
	"./adapters/svgs/IVART1000.svg": 44231,
	"./adapters/svgs/IVART3000.svg": 94916,
	"./adapters/svgs/IVART5000.svg": 61780,
	"./adapters/svgs/IVARTD3000.svg": 32147,
	"./adapters/svgs/JAGADecoChrome.svg": 70162,
	"./adapters/svgs/JAGADecoComapSilver.svg": 12058,
	"./adapters/svgs/JAGARAL9005.svg": 17991,
	"./adapters/svgs/JAGARAL9016.svg": 33785,
	"./adapters/svgs/MMADTW.svg": 45131,
	"./adapters/svgs/MMAEvosensePublic.svg": 59982,
	"./adapters/svgs/MMAEvosenseSprint.svg": 86501,
	"./adapters/svgs/MMAEvosenseStandard.svg": 6226,
	"./adapters/svgs/MMAMTWAD.svg": 36736,
	"./adapters/svgs/MysonPetite.svg": 81795,
	"./adapters/svgs/MysonTRV2Way.svg": 35142,
	"./adapters/svgs/OrkliAduna.svg": 12706,
	"./adapters/svgs/OrkliArima-Eroso.svg": 8051,
	"./adapters/svgs/OrkliHarmony.svg": 10728,
	"./adapters/svgs/OrkliTala.svg": 1709,
	"./adapters/svgs/OventropPinoxD.svg": 86756,
	"./adapters/svgs/OventropPinoxH.svg": 64460,
	"./adapters/svgs/OventropUniL.svg": 8695,
	"./adapters/svgs/OventropUniLA.svg": 54286,
	"./adapters/svgs/OventropUniLD.svg": 17132,
	"./adapters/svgs/OventropUniLDV.svg": 53247,
	"./adapters/svgs/OventropUniLDVL.svg": 21285,
	"./adapters/svgs/OventropUniLH.svg": 56266,
	"./adapters/svgs/OventropUniLHB.svg": 84758,
	"./adapters/svgs/OventropUniLI.svg": 60969,
	"./adapters/svgs/OventropUniLK.svg": 11642,
	"./adapters/svgs/OventropUniLM.svg": 42006,
	"./adapters/svgs/OventropUniLO.svg": 3518,
	"./adapters/svgs/OventropUniLR.svg": 63989,
	"./adapters/svgs/OventropUniLV.svg": 15613,
	"./adapters/svgs/OventropUniSH.svg": 67753,
	"./adapters/svgs/OventropUniXH.svg": 27722,
	"./adapters/svgs/OventropUniXHM.svg": 55030,
	"./adapters/svgs/OventropVindoCH.svg": 62779,
	"./adapters/svgs/OventropVindoTH.svg": 18375,
	"./adapters/svgs/OventropVintoRTD.svg": 82551,
	"./adapters/svgs/OventropVintoTD.svg": 94112,
	"./adapters/svgs/PeglerBullDog.svg": 54623,
	"./adapters/svgs/Pettinaroli105LHC.svg": 38321,
	"./adapters/svgs/Pettinaroli105TC.svg": 52574,
	"./adapters/svgs/Pettinaroli106CN.svg": 44000,
	"./adapters/svgs/Pettinaroli106LHN.svg": 29907,
	"./adapters/svgs/Pettinaroli107L.svg": 97136,
	"./adapters/svgs/Pettinaroli107LD-107LKIT.svg": 50708,
	"./adapters/svgs/Pettinaroli107LHC.svg": 49712,
	"./adapters/svgs/Pettinaroli107LHN-1.svg": 16932,
	"./adapters/svgs/Pettinaroli107LHN-2.svg": 34559,
	"./adapters/svgs/Pettinaroli107LHN.svg": 5616,
	"./adapters/svgs/Pettinaroli107LKIH-107LKIS.svg": 25239,
	"./adapters/svgs/Pettinaroli107LKIH.svg": 92567,
	"./adapters/svgs/Pettinaroli107LM28x1.5.svg": 19923,
	"./adapters/svgs/Pettinaroli107LOD.svg": 49753,
	"./adapters/svgs/Pettinaroli107LR.svg": 88621,
	"./adapters/svgs/Pettinaroli108L.svg": 38818,
	"./adapters/svgs/Pettinaroli109.svg": 58086,
	"./adapters/svgs/Pettinaroli109L.svg": 418,
	"./adapters/svgs/Pettinaroli109LChrome.svg": 79655,
	"./adapters/svgs/Pintossi130.svg": 44991,
	"./adapters/svgs/Pintossi13030000.svg": 21572,
	"./adapters/svgs/SARCOMAPModel1.svg": 48352,
	"./adapters/svgs/SARCOMAPModel2.svg": 72022,
	"./adapters/svgs/SARCOMAPSensitiveBlanc.svg": 94732,
	"./adapters/svgs/SARCOMAPSensitiveChrome.svg": 66442,
	"./adapters/svgs/SARCOMAPSensity.svg": 54634,
	"./adapters/svgs/SARCOMAPSenso.svg": 37504,
	"./adapters/svgs/SARCOMAPSensoallcolor.svg": 23458,
	"./adapters/svgs/SARCOMAPSensoold.svg": 7658,
	"./adapters/svgs/SARCOMAPThermostaticHeadW5.svg": 78292,
	"./adapters/svgs/SARCOMAPWESTHERM5.svg": 98399,
	"./adapters/svgs/SchlosserBrillantPlusSeries.svg": 88640,
	"./adapters/svgs/SchlosserBrillantSeries.svg": 48294,
	"./adapters/svgs/SchlosserC-DiamantPlusSeries.svg": 24246,
	"./adapters/svgs/SchlosserC-DiamantSeries.svg": 58689,
	"./adapters/svgs/SchlosserDR-DiamantPlusSeries.svg": 19196,
	"./adapters/svgs/SchlosserDR-DiamantSeries.svg": 1759,
	"./adapters/svgs/SchlosserDiamantPlusSeries.svg": 45906,
	"./adapters/svgs/SchlosserDiamantSeries.svg": 56082,
	"./adapters/svgs/SchlosserHTDiamantPlusSeries.svg": 96012,
	"./adapters/svgs/SchlosserHTDiamantSeries.svg": 1506,
	"./adapters/svgs/SchlosserMiniSeries.svg": 5454,
	"./adapters/svgs/SchlosserSH-DiamantInvest.svg": 26879,
	"./adapters/svgs/SchlosserSH-DiamantPlusSeries.svg": 85551,
	"./adapters/svgs/SchlosserSH-DiamantSeries.svg": 42229,
	"./adapters/svgs/SiemensMTN51GBTRV.svg": 49711,
	"./adapters/svgs/SiemensRT56.05.svg": 69042,
	"./adapters/svgs/SiemensRTN.svg": 32848,
	"./adapters/svgs/SiemensRTN51.svg": 16328,
	"./adapters/svgs/SiemensTrade.svg": 80920,
	"./adapters/svgs/SunvicTRV200.svg": 67232,
	"./adapters/svgs/SunvicTRV300.svg": 91275,
	"./adapters/svgs/SunvicTRV500.svg": 56687,
	"./adapters/svgs/SunvicTRV510.svg": 44101,
	"./adapters/svgs/TATRV300.svg": 43211,
	"./adapters/svgs/Tiemme9553.svg": 83658,
	"./adapters/svgs/Tiemme9556.svg": 5051,
	"./adapters/svgs/Tiemme9559.svg": 41315,
	"./adapters/svgs/ValfSanayiiECA.svg": 35554,
	"./adapters/svgs/ValfSanayiiTRV1.svg": 10999,
	"./adapters/svgs/ValfSanayiiTRV2.svg": 93064,
	"./adapters/svgs/ValvexFusion.svg": 12860,
	"./adapters/svgs/ValvexIris.svg": 86485,
	"./adapters/svgs/ValvexThermo.svg": 48562,
	"./adapters/svgs/ValvexVector.svg": 66014,
	"./adapters/svgs/ValvexVirgo.svg": 66980,
	"./assets/images/back-arrow.svg": 85691,
	"./assets/images/compatible-vicki.svg": 31307,
	"./assets/images/incompatible-vicki.svg": 18550,
	"./assets/images/logo.svg": 82835,
	"./assets/images/search.svg": 73794,
	"./assets/images/vicki-r-image.svg": 51485,
	"./assets/images/vicki.svg": 61132,
	"./brands/Alliance.png": 1265,
	"./brands/Altecnic.png": 42687,
	"./brands/Arco.png": 9864,
	"./brands/BRV.png": 16441,
	"./brands/BathEmpire.png": 82590,
	"./brands/Blyss.png": 29122,
	"./brands/Boss.png": 78887,
	"./brands/Caleffi.png": 60652,
	"./brands/Danfoss.png": 78508,
	"./brands/Drayton.png": 28164,
	"./brands/ECA.png": 83669,
	"./brands/EMMETI.png": 16666,
	"./brands/EQ-3.png": 94263,
	"./brands/EUROTRONIC.png": 63789,
	"./brands/Eberle.png": 705,
	"./brands/Elgato.png": 15140,
	"./brands/FAR.png": 43278,
	"./brands/GAMPPERARMATUREN.png": 82656,
	"./brands/GENEBRE.png": 12881,
	"./brands/Giacomini.png": 36066,
	"./brands/Heimeier.png": 77291,
	"./brands/Herz.png": 80084,
	"./brands/HoneywellBraukmann.png": 48889,
	"./brands/IVAR.png": 58750,
	"./brands/Jaga.png": 85679,
	"./brands/Landis&gyr.png": 62595,
	"./brands/MMA.png": 16253,
	"./brands/MNG.png": 79213,
	"./brands/Myson.png": 87845,
	"./brands/Orkli.png": 42750,
	"./brands/Oventrop.png": 36313,
	"./brands/Pegler.png": 66291,
	"./brands/Pettinaroli.png": 38316,
	"./brands/Pintossi.png": 54137,
	"./brands/Polytronic.png": 77980,
	"./brands/Pont-à-Mousson.png": 13395,
	"./brands/RBMrobsom.png": 56506,
	"./brands/Rossweiner.png": 26801,
	"./brands/Sam-Slovarm.png": 58805,
	"./brands/SarComap.png": 74459,
	"./brands/Schlosser.png": 17033,
	"./brands/Siemens.png": 80230,
	"./brands/Sunvic.png": 6115,
	"./brands/TA.png": 37206,
	"./brands/TADO.png": 34784,
	"./brands/Tiemme.png": 51924,
	"./brands/Vaillant.png": 12078,
	"./brands/ValfSanayii.png": 95565,
	"./brands/Valvex.png": 50697,
	"./brands/Watts.png": 27486,
	"./index": 18305,
	"./index.css": 51174,
	"./index.js": 18305,
	"./info": 27799,
	"./info.js": 27799,
	"./logo.svg": 31100,
	"./reportWebVitals": 54013,
	"./reportWebVitals.js": 54013,
	"./setupTests": 79511,
	"./setupTests.js": 79511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40407;